const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_public.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSessionQuery } from '@/features/identity/lib/get-session.query';
import { isInternalPath } from '@/app/lib/internal-path';
export const Route = createFileRoute('/_public')({
  beforeLoad: async ({
    context,
    location
  }) => {
    const session = await context.queryClient.ensureQueryData(getSessionQuery({
      controllers: {
        authController: context.deps.controllers.authController
      }
    }));
    if (!session) {
      return;
    }
    const search = location.searchStr.startsWith('?') ? location.searchStr.slice(1) : location.searchStr;
    const next = new URLSearchParams(search).get('next');
    if (next && isInternalPath(next)) {
      throw redirect({
        href: next
      });
    }
    throw redirect({
      to: '/'
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});